import ApiClient from '@afosto/api/ApiClient';

class Parcels {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Add items to parcel
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add items to a parcel
   * @returns {Promise}
   */
  addToParcel(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}/items`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Create parcel
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new parcel to the list
   * @returns {Promise}
   */
  createParcel(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * View parcel
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a single parcel
   * @returns {Promise}
   */
  getParcel(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * List parcels
   *
   * @param {Object} options - The additional request options
   * @description List all parcels
   * @returns {Promise}
   */
  listParcels(options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Remove items from parcel
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Remove items from parcel
   * @returns {Promise}
   */
  removeFromParcel(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}/items`,
      method: 'delete',
      data: body,
      ...options,
    });
  }

  /**
   * Remove a parcel
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Remove a parcel
   * @returns {Promise}
   */
  removeParcel(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Request label
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Requests a label for the parcel
   * @returns {Promise}
   */
  requestLabel(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}/label`,
      method: 'post',
      ...options,
    });
  }

  /**
   * Request slip
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Requests packing slip
   * @returns {Promise}
   */
  requestSlip(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}/slip`,
      method: 'post',
      ...options,
    });
  }

  /**
   * Mark finished
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Mark parcel as finished
   * @returns {Promise}
   */
  setParcelFinished(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}/finished`,
      method: 'put',
      ...options,
    });
  }

  /**
   * Mark transit
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Mark parcel as in-transit
   * @returns {Promise}
   */
  setParcelInTransit(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}/transit`,
      method: 'put',
      ...options,
    });
  }

  /**
   * Update a parcel
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update the parcel parameters
   * @returns {Promise}
   */
  updateParcel(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/parcels/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const parcels = new Parcels();

export default Parcels;
